import debugLib from 'debug';
import { reducerWrapper } from '../support/utils';
import { GET_AD_ACCOUNT_STATUS } from '../actions/SANPartnerActions';

const debug = debugLib('TiktokSANReducer');

export const INIT_STATE = {
  adAccountStatus: {},
};

/* eslint-disable @typescript-eslint/default-param-last*/
function Handler(state = INIT_STATE, action) {
  debug('Receive action type ', action.type);
  switch (action.type) {
    case GET_AD_ACCOUNT_STATUS.response:
      return {
        ...state,
        adAccountStatus: action.data && action.data.a_tiktok,
      };

    default:
      return state;
  }
}

const Tiktok = reducerWrapper(INIT_STATE, Handler, {
  request: [GET_AD_ACCOUNT_STATUS],
  error: [GET_AD_ACCOUNT_STATUS],
  resetOn: ['APP_CHANGE'],
});

export default Tiktok;
